import Base64 from './base64';

// Local URL
//export const TMS_API_BASE_URL = "http://localhost:49447/api/";
// DEV URL
export const TMS_API_BASE_URL = "https://dev.flagstone.tech/mysoft.tms.api/api/";
// QUA URL
//export const TMS_API_BASE_URL = "https://qua.flagstone.tech/mysoft.tms.api/api/";
// SRVOneFigure IIS url
// export const TMS_API_BASE_URL = "http://192.168.8.15/Mysoft.TMS.API/api/";

export const API_USER_NAME = "tmsAppUser";
export const API_PASSWORD = "faWUC96wYzCk";

export const API_ACTION_ACTIVE_ORDERS = "Dashboard/GetActiveTransportOrders";
export const API_ACTION_COMPLETED_ORDERS = "Dashboard/GetCompletedTransportOrders";
export const API_ACTION_ORDERS_HISTORY = "Dashboard/GetTransportOrdersHistory";
export const API_ACTION_SENDABLE_STATES = "Dashboard/CalculateSendableStates";

export const API_ACTION_BLOCKED_MACHINES= "Dashboard/GetBlockedPackagingMachines";
export const API_ACTION_BLOCK_LINE = "Dashboard/BlockTransportsToPackagingMachine";
export const API_ACTION_UNBLOCK_LINE = "Dashboard/UnBlockTransportsToPackagingMachine";

export const API_ACTION_SEND_STATUS = "Dashboard/SendStatus";
export const API_ACTION_CANCEL_TRANSPORTORDER = "Dashboard/CancelTransportOrder";

export const API_ACTION_LOGIN = "Account/AuthenticateUser";

export function ComposeUri(baseAddress, action){
    console.log(baseAddress + action);
    return baseAddress + action;
}

export function ComposeAuthToken(){
    return 'Basic ' + Base64.btoa(API_USER_NAME + ':' + API_PASSWORD);
}